import { render, staticRenderFns } from "./InvoicesPage.vue?vue&type=template&id=4eee2d65&scoped=true"
import script from "./InvoicesPage.vue?vue&type=script&lang=ts"
export * from "./InvoicesPage.vue?vue&type=script&lang=ts"
import style0 from "./InvoicesPage.vue?vue&type=style&index=0&id=4eee2d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eee2d65",
  null
  
)

export default component.exports